import { usePageEventContext, withPageEvent } from '../../../shared/flow-event';
import { createInitialState, createTracker } from './tracker';
import type {
  LoginByPasswordOneCredentialFlowEventDefinition,
  LoginByPasswordOneCredentialFlowEventState,
} from './types';

export function useLoginByPasswordOneCredentialFlowEvent() {
  return usePageEventContext<LoginByPasswordOneCredentialFlowEventDefinition>();
}

export function withLoginByPasswordOneCredentialFlowEvent<
  Props extends object = {}
>() {
  return withPageEvent<
    LoginByPasswordOneCredentialFlowEventDefinition,
    LoginByPasswordOneCredentialFlowEventState,
    Props
  >(createInitialState(), createTracker());
}
